<template>
  <div class="Dialog">
    <div class="main">
      <div class="left">
        <div class="left-tab" :class="leftCur == index ? 'active' : ''" v-for="(item, index) in leftTabs[val-1]"
          :key="index" @mouseenter="bg(index)">{{ item.tab }}</div>
      </div>
      <div class="right" v-if="val == 1">
        <div v-if="leftInd == '0'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">智能合同管理平台</div>
              <div class="bar"></div>
              <div class="cont">
                <div class="contentBox">
                  <p>
                    智能合同管理平台以项目、合同为源头的全生命周期的智能合同管理，包含合同评审、合同签订、合同变更、合同结算、合同发票、合同收付款管理,可支持不同行业的采购合同、销售合同、物资合同、分包合同、设备合同及其他合同管理并支持建筑行业的建造成本管理、建安收支管理等及线上电子签合同管理。
                  </p>
                </div>
                <div class="tit mgtop10 mgbot10">
                  <div class="fs-3 w-700 lyd-title-colo1">产品架构</div>
                  <div class="bar"></div>
                </div>
                <img class="jiagou1 mrgintop0" src="../assets/images/portfolio/dialog/eec/智能合同管理平台.png" alt="" />
              </div>
            </div>
          </div>
          <div class="two" style="margin-top: 90px;">
            <div class="fs-2 w-700 lyd-title-colo1">整体价值</div>
            <div class="bar"></div>
            <div class="cont2">
              <ul class="padHeight">
                <li>系统化控制：避免因业务流程复杂导致的合同生命周期过长</li>
                <li>
                  合同台账预警：对合同进度、结款等关键节点的预警，具体实施进度随时掌握，对一些异常情况及时作出反应，规避合同执行脱节，不能按时交底
                </li>
                <li>合同的履行：避免因工作繁忙对合同的重要节点把控不及时</li>
                <li>业务关联：满足业务间流程的贯通，合同数据的抽取，大大增加时间成本，降低工作效率。</li>
              </ul>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '1'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">智慧业财管理平台</div>
              <div class="bar"></div>
              <div class="cont">
                <div class="contentBox">
                  <p>
                    智慧业财管理平台是包含智能报账（如商旅与费控、采购业财、销售业财、人力业财、资产业财、收入管理、收款认领等）、发票管理、一键报税、资金结算、电子影像、电子档案、智能技术、移动应用、项目管理和行业属性等全场景、一站式的业财一体化管理平台，由业务人员直接发起,相应的业务控制、预算控制、资金控制、费用控制将前移至各种业务场景的业务报账单,实现“业、财、税、资、档”的横向贯通。
                  </p>
                </div>
                <div class="contentImg">
                  <div class="tit mgtop10 mgbot10">
                    <div class="fs-3 w-700 lyd-title-colo1">产品架构</div>
                    <div class="bar"></div>
                  </div>
                  <img class="jiagou1 mrgintop0 mgbot15" src="../assets/images/portfolio/dialog/eec/智能业财管理平台1.png"
                    alt="" />
                </div>
              </div>
            </div>
            <div class="two">
              <div class="fs-2 w-700 lyd-title-colo1">产品模块</div>
              <div class="bar"></div>
              <div class="cont2 mt3">
                <p>
                  <!-- 智慧业财管理平台包括智能报账、发票管理、电子影像、电子档案、智能技术、一键报税、资金结算、移动应用、连接器和会计引擎等。 -->
                  智慧业财管理平台依托智能技术应用，主要包括智能报账、发票管理、电子影像与电子档案、一键报税、资金结算、移动应用、连接器和会计引擎等功能。
                </p>
                <div class="tags">
                  <div class="tag" :class="rightCur == index ? 'active2' : ''" @mouseenter="tag(index)"
                    v-for="(item, index) in rightTabs" :key="index">
                    {{ item.tag }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <tags :ind="ind"></tags>
          </div>
        </div>
        <div v-if="leftInd == '2'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">共享运营平台</div>
              <div class="bar"></div>
              <div class="cont">
                <div class="contentBox">
                  <p>
                    任务提取规则、任务派单规则、单据模板设置、共享服务中心任务处理、作业任务管理、任务查询、绩效考评等模块。
                  </p>
                  <ul class="padHeight">
                    <li>
                      委托组织：灵活定义业务组织提交业务（费用管理、应收管理、应付管理、资金管理、自有表单模块业务）单据后，可以委托哪个共享服务中心处理；
                    </li>
                    <li>任务量设定：可按需设置限制作业人员的在手待处理任务量，提升共享作业效率；</li>
                    <li>派单规则：可以科学按业务组织、单据类型、交易类型、高级条件等不同维度设置派单规则；</li>
                    <li>
                      共享任务作业平台：基于角色的门户应用提供一站式工作起点、提供专事专岗统一界面进行集中作业审核处理，提供双屏审单、自动制证提高工作效率，通过对工作量的计量、量比实现规范运营和质量管控。
                    </li>
                  </ul>
                </div>
                <div class="contentImg mgbot15">
                  <div class="tit">
                    <div class="fs-3 w-700 lyd-title-colo1">产品架构</div>
                    <div class="bar"></div>
                  </div>
                  <img class="jiagou1 mrgintop0" src="../assets/images/portfolio/dialog/eec/共享运营平台1.png" alt="" />
                </div>
              </div>
            </div>
            <div class="two">
              <div class="fs-2 w-700 lyd-title-colo1">产品模块</div>
              <div class="bar"></div>
              <div class="cont2 mt3">
                <p>
                  共享运营平台作为共享服务中心人员日常工作、管理的主要平台，包括：共享组织架构、任务提取规则、任务派单规则、共享服务中心任务处理、作业任务管理、任务查询、绩效管理等模块。
                </p>

                <ul class="padHeight">
                  <li>
                    <div>共享组织架构</div>
                    <div class="padHeight-item">
                      <p>
                        实现共享服务委托关系以及共享中心岗位设置，支持一个企业按照板块、区域业务模式差异划分多个共享中心，共享中心下设作业处理小组及业务岗位，系统支持分级设置岗位且可针对不能级次的岗位实现权限划分。
                      </p>
                      <!-- <img src="../assets/images/portfolio/dialog/eec/共享运营平台2.png" alt="" /> -->
                    </div>
                  </li>
                  <li>
                    <div>任务提取规则</div>
                    <div class="padHeight-item">
                      <p>
                        任务提取规则是财务共享服务中心的基础设置，用于定义每次提取任务量，设置是否要限制作业人员的在手待处理任务量。用于避免业务人员一次提取过多的任务，导致任务压单，影响业务的处理效率和客户满意度。
                      </p>
                      <img src="../assets/images/portfolio/dialog/eec/共享运营平台3.png" alt="" />

                    </div>
                  </li>
                  <li>
                    <div>任务派单规则</div>
                    <p class="mt3">
                      任务派单规则是共享服务中心的管理员可以使用此功能将任务分配给具体岗位，派单规则是系统对任务池派工时的分组派送的依据，规则的设置直接影响后续任务处理时的任务提取和任务分配与调整的可操作任务范围。对于一些难度比较大的作业，可以通过任务派单规则指派给比较有经验的人员来进行处理，确保业务处理的效率和质量。
                    </p>
                  </li>
                  <li>
                    <div>作业任务处理</div>
                    <div class="padHeight-item">
                      <p>
                        共享服务中心的业务人员可以通过此节点提取并处理任务，处理自的日常业务。共享作业人员可对单据进行审批通过或者驳回操作，支持将单据驳回影像岗位进行影像调整，支持将提取到单据申请调整至其他作业人员审批。
                      </p>
                      <img src="../assets/images/portfolio/dialog/eec/共享运营平台4.png" alt="" />
                    </div>
                  </li>
                  <li>
                    <div>作业任务管理</div>

                    <div class="padHeight-item">
                      <p>
                        任务管理主要是针对业务组长的，业务组长可以通过调整任务优先级等方式，将任务池中的未分配的任务指派给本组组员、将已分配未处理的任务取回到任务池。
                      </p>
                      <img src="../assets/images/portfolio/dialog/eec/共享运营平台5.png" alt="" />
                    </div>
                  </li>
                  <li>
                    <div>任务查询</div>
                    <p class="mt3">
                      共享服务中心的负责人可以通过任务查询，对任务池进行查询统计，查看任务池中不同状态的任务量，任务详细信息，任务处理时效等信息。
                    </p>
                  </li>
                  <li>
                    <div>绩效管理</div>
                    <div class="padHeight-item">
                      <p>共享绩效数字厅反映共享服务中心的单据处理量、单据处理效率、单据报账周期、退单率等信息。</p>
                      <img src="../assets/images/portfolio/dialog/eec/共享运营平台6.png" alt="" />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="two">
              <div class="fs-2 w-700">整体价值</div>
              <div class="bar"></div>
              <div class="cont2">
                <ul class="padHeight">
                  <li>
                    <div>系统稳定:</div>
                    <p>
                      建立多重预防性维护（如高质可用架构、系统效率监控、周期性性能检查等），提前识别操作风险，并进行及时处理
                    </p>
                  </li>
                  <li>
                    <div>降低成本：</div>
                    <p>通过共享模式的管理可以有效的降低总体成本（包括硬件投入成本、软件成本、人工成本等）</p>
                  </li>
                  <li>
                    <div>降低负担：</div>
                    <p>通过自动化，将低附加值的工作外包来替代运营人员的工作，让运营人员聚焦到更有价值的事务上；</p>
                  </li>
                  <li>
                    <div>价值提升：</div>
                    <p>通过财务共享运营实现业务转型创新，从运营层面报账财务共享中心工作预期目标得以实现。</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '3'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <h3 class="fs-2 w-700 lyd-title-colo1">行业特性应用</h3>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="fs-2 w-700 lyd-title-colo1">项目管理</div>
                <div class="bar"></div>
                <p>项目管理平台：包括项目立项、项目进度、项目预算管理。</p>
                <ul class="padHeight">
                  <li>
                    加强公司对项目投标、合同、过程执行到竣工的过程管控能力，降低项目风险
                  </li>
                  <li>建立计划管理体系，强化计划管理，加强过程成本控制</li>
                  <li>构建全过程项目管理平台，以项目进度管理、成本管理为核心</li>
                  <li>
                    通过信息化推动企业标准化建设落地，实现管理制度化、制度流程化、流程表单化、表单信息化
                  </li>
                </ul>
              </div>
            </div>
            <div class="two">
              <div class="fs-2 w-700 lyd-title-colo1">建筑行业特性</div>
              <div class="bar"></div>
              <div class="cont2 mt3">
                <p>
                  建造成本管理、建安收支管理属于建筑行业特性产品
                </p>

                <ul class="padHeight">
                  <li>
                    <div class="padHeight-item">
                      <p>通过建造成本管理可以掌握收入与成本情况及工程形象进度情况，从而达到及时跟业主确权、控制分包成本、控制物资领用、确认工程产值、发起资金计划、计算当期利润等，及时对项目成本进行预警。
                      </p>
                      <img src="../assets/images/portfolio/dialog/eec/行业特性应用1.png" alt="" />
                    </div>
                  </li>
                  <li>
                    <div class="padHeight-item">
                      <p>通过建安收支管理进行收入成本确认，统计合同预计收入、预计成本及毛利，计算本期完工百分比及本期确认收入等信息。</p>
                      <img src="../assets/images/portfolio/dialog/eec/行业特性应用2.png" alt="" />
                    </div>

                  </li>
                </ul>
              </div>
            </div>
            <div class="two mt3">
              <div class="fs-2 w-700 lyd-title-colo1">地产行业特性</div>
              <div class="bar"></div>
              <div class="cont2 mt3">
                <p>
                  地产行业结转成本分为三大步，第一步成本暂估，第二步结转开发产品，第三步结转主营业务成本。
                </p>

                <ul class="industry">
                  <li>
                    <div class="padHeight-item mb10">
                      <img src="../assets/images/portfolio/dialog/eec/行业特性应用3.png" alt="" />
                      <p>系统出具成本暂估明细表及单方成本核对表</p>
                    </div>
                  </li>
                  <li>
                    <div class="padHeight-item mb10">
                      <img src="../assets/images/portfolio/dialog/eec/行业特性应用4.png" alt="" />
                      <p>结转开发产品</p>
                    </div>
                  </li>
                  <li>
                    <div class="padHeight-item">
                      <img src="../assets/images/portfolio/dialog/eec/行业特性应用5.png" alt="" />
                      <p>结转主营业务成本</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="two">
              <div class="fs-2 w-700">整体价值</div>
              <div class="bar"></div>
              <!-- <div class="contentImg mgbot15">
								<img class="jiagou1 mrgintop0" src="../assets/images/portfolio/dialog/eec/行业特性应用6copy.png" alt="" />
							</div> -->
              <div class="cont2">
                <ul class="padHeight">
                  <li>
                    <p>项目数字化管控：助力企业实现企业全项目周期管理，有效提升项目数字化管控力度。</p>
                  </li>
                  <li>
                    <p>资金动态时时监控：可按企业各层级的管理模式和流程对项目资金统一管控和内部划拨 , 达到实时掌控资金动态数据情况，实现对项目资金的计划、执行进行实时监控及控制。</p>
                  </li>
                  <li>
                    <p>成本可视化管理：实现对项目成本的可视化管理，并进行全自动成本归集及统计，建立了业务与资金一体化过程管控，并可实时进行数据联查。</p>
                  </li>
                  <li>
                    <p>业财资税全面融合：形成以项目 - 合同 - 预算 - 结算 - 发票 - 收付款 - 成本为主线的管控模式，达成业财资税全面融合。</p>
                  </li>
                </ul>
              </div>
              <!-- <div class="cont2">
								<img src="../assets/images/portfolio/dialog/eec/行业特性应用6copy.png" alt="">
							</div> -->
            </div>
            <div class="two">
              <div class="fs-2 w-700">产品优势</div>
              <div class="bar"></div>
              <div class="cont2">
                <ul class="padHeight">
                  <li>
                    <p>优势一：从合同履行、项目执行到项目竣工结算的项目全过程管理；</p>
                  </li>
                  <li>
                    <p>优势二：通过对项目的事前、事中、事后的全过程施工过程管理实现业务、财务数据的有机统一；</p>
                  </li>
                  <li>
                    <p>优势三：实现核算、决算闭环，并实现人工、材料、机械、其他费用等全成本管理；</p>
                  </li>
                  <li>
                    <p>优势四：业务财务一体化，业务流、资金流、信息流三流合一，并于财务系统无缝对接；</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right" v-if="val == 2">
        <div v-if="leftInd == '0'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">智能合同管理平台</div>
              <div class="bar"></div>
              <div class="cont">
                <div class="contentBox">
                  <p>
                    智能合同管理平台以项目、合同为源头的全生命周期的智能合同管理，包含合同评审、合同签订、合同变更、合同结算、合同发票、合同收付款管理,可支持不同行业的采购合同、销售合同、物资合同、分包合同、设备合同及其他合同管理并支持建筑行业的建造成本管理、建安收支管理等及线上电子签合同管理。
                  </p>
                </div>
                <div class="tit mgtop10 mgbot10">
                  <div class="fs-3 w-700 lyd-title-colo1">产品架构</div>
                  <div class="bar"></div>
                </div>
                <img class="jiagou1 mrgintop0" src="../assets/images/portfolio/dialog/eec/智能合同管理平台.png" alt="" />
              </div>
            </div>
          </div>
          <div class="two" style="margin-top: 90px;">
            <div class="fs-2 w-700 lyd-title-colo1">整体价值</div>
            <div class="bar"></div>
            <div class="cont2">
              <ul class="padHeight">
                <li>系统化控制：避免因业务流程复杂导致的合同生命周期过长</li>
                <li>
                  合同台账预警：对合同进度、结款等关键节点的预警，具体实施进度随时掌握，对一些异常情况及时作出反应，规避合同执行脱节，不能按时交底
                </li>
                <li>合同的履行：避免因工作繁忙对合同的重要节点把控不及时</li>
                <li>业务关联：满足业务间流程的贯通，合同数据的抽取，大大增加时间成本，降低工作效率。</li>
              </ul>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '1'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">智能报账</div>
              <div class="bar"></div>
              <div class="cont">
                <div class="flex-one">
                  <p>
                    智能合同管理平台以项目、合同为源头的全生命周期的智能合同管理，包含合同评审、合同签订、合同变更、合同结算、合同发票、合同收付款管理，支持不同行业的采购合同、销售合同、物资合同、分包合同、设备合同及其他合同管理。支持建筑行业的建造成本管理、建安收支管理等。也支持线上电子签合同管理。
                  </p>
                  <img class="flex-one-img1" src="@/assets/images/portfolio/dialog/eec/智能报账.png" alt="" />
                </div>
                <h5 class="padHeight">商旅与费控一体化管理：</h5>
                <img class="padHeight_imgmian2 mrgintop0 mt3" src="@/assets/images/portfolio/dialog/esc/智能报账2.png"
                  alt="" />
                <br>
                <img class="padHeight_imgmian2 mrgintop0 mt3" src="@/assets/images/portfolio/dialog/esc/智能报账3.png"
                  alt="" />
                <br>
                <div class="flex-one">
                  <p class="padHeight">
                    在聚合企业商旅->智能报账->企业付款->企业核算的全流程各环节支持丰富的事前、事中、事后的管控模式和智能化、自动化技术，赋能业务提效与创新。</p>
                  <img class="flex-one-img1" src="@/assets/images/portfolio/dialog/eec/智能报账3copy.png" alt="" />
                </div>
                <h5 class="padHeight">对公业务的企业支出一体化管理：</h5>
                <ul class="padHeight">
                  <li>与供应链、项目管理、人力管理、资产管理等一体化的企业支出管理，可真正实现财务业务一体化处理，提高业务处理效率，杜绝人为错误发生。</li>
                  <li>保证业务发生的合规合法性，基于财务业务一体化，保证数出同源，经过有效审批，为后续实际付款提供有效查询和支持。</li>
                  <li>可实现每笔采购应付业务的可分析、可追溯。</li>
                  <li>可通过EECloud进行采购应付和付款业务的核销处理，并为后续的财务分析提供更细颗粒度的数据支持。</li>
                  <li>实现资产一体化管理。</li>
                </ul>
                <h5 class="padHeight">业务收入一体化管理：</h5>
                <div>
                  <p>EECloud业务收入一体化管理包括销售业财即销售管理系统与应收收入确认的一体化管理以及收款认领管理。</p>
                  <ul class="padHeight">
                    <li>根据客户业务情况，控制应收账款的限额和收回的时间，以确保企业营运资金的循环周转。</li>
                    <li>规范应收、收款管理，规避业务人员进行回款调整、违规发货，避免应收账款管理失控风险。</li>
                    <li>充分估计应收账款的持有成本和风险。</li>
                    <li>及时组织安排到期和逾期的应收账款的催收，避免企业资金被占用。</li>
                    <li>精准分析客户画像与利润贡献。</li>
                  </ul>
                </div>
              </div>
              <div class="conts mt3 conts-alinetimecenter">
                <div class="contentBox width55">
                  <p>通过合同、客户相关业务处理，实现应收款项核销、自动进行往来对账、结算管理，提供应收款项回款分析、账龄分析、周转分析、往来对账等功能，并能根据不同设置提供债权、催款提示等。
                  </p>
                  <p>通过收款认领平台，基于银行下载流转/手工导入流水，人工/系统自动认收款流水生成收款单据，收款单审核通过自动结算入账处理。实现收款单、电子回单、凭证三单匹配。
                  </p>
                </div>
                <img class="imgeec1-1" src="@/assets/images/portfolio/dialog/eec/智能报账4.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '2'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">发票管理</div>
              <div class="bar"></div>
              <div class="conts mt3">
                <p class="width55">
                  EECloud发票管理与智能报账、影像系统、税务管理一体化应用，实现进项发票的归集、自动查验、自动查重、解析、存管、报销入账等全流程过程管理。</p>
                <img class='imgeec1-2' src="@/assets/images/portfolio/dialog/eec/发票管理1.png" alt="" />
              </div>
              <div class="conts mt3">
                <p class="width55">
                  产品支持发票夹采集发票功能，票小记发票夹提供APP和微信小程序两种使用途径，支持拍照采集、上传图片、扫描二维码、微信卡包引入、文件导入、手工采集等6种方式采集发票信息，且支持对增值税发票进行查验，票据自动转存影像文件，用于报销审核及电子档案存储。对已采集的发票可进行转让，适用于多种业务报账场景。
                </p>
                <img class='imgeec1-3' src="@/assets/images/portfolio/dialog/eec/发票管理2.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '3'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">电子影像与电子档案管理</div>
              <div class="bar"></div>
              <div class="cont">
                <p>EECloud影像管理是通过手机APP、扫描仪、高拍仪等进行发票、纸质单据的扫描以及OCR光学识别，实现业务系统运营集中化、纸质单据影像化、业务流程处理便捷化。</p>
                <p>
                  建立企业级影像管理平台，将合同、对账单、发票等都扫描管理，通过发票号、合同号、对账单号等任何一个信息都可以查询到相关的档案。通过此功能，一次查询就可以实现将整个业务链产生的所有档案全部进行显示调阅，实现业务可追溯，提升企业运营效率。
                </p>
                <img class="imgmian2 mrgintop0 mt3" src="@/assets/images/portfolio/dialog/eec/电子影像1.png" alt="" />
                <p>构建电子档案统一管理体系，实现文件资料的分类、归档、上传、下载、检索、管理等全业务电子化、自动化归档并拥有可靠的安全性，对所有的电子档案资料进行生命周期管理。</p>
                <p>通过会计档案的无纸化管理，减少企业打印成本、IT耗材、存管人力和空间成本等，节能减排，绿色环保，减少生产办公成本。</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '4'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">一键报税</div>
              <div class="bar"></div>
              <div class="cont">
                <p>
                  EECloud增值税管理系统为企业提供了税务业务处理方案，通过发票夹多种采集方式进行发票采集，与报账系统关联引用发票信息便捷填单，系统按照税法要求自动进行价税分离，满足增值税核算要求。并与核算系统对接，实时传递发票对应账务信息，且与税局对接，实现一键认证。
                </p>
                <p>
                  EECloud增值税管理系统，实现从业务到财务再到税务核算、纳税申报的顺畅操作。通过系统层级的“业财税一体化”，为增值税核对“票、账、表”信息提供了依据。EECloud增值税严密的管理不仅帮助企业保证缴税的合规性、合法性，更起到了降低税负风险的作用。
                </p>
                <p>增值税系统出具进项发票台账、抵扣统计表以及其他扣税明细表等统计报表且关联单据以及财务入账凭证，便于税务人员进行查询统计。</p>
                <img class="imgmian2 mrgintop0 mt3" src="@/assets/images/portfolio/dialog/eec/一键报税.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '5'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">资金结算</div>
              <div class="bar"></div>
              <div class="cont">
                <p>
                  EECloud统一资金结算平台，实现资金业务处理信息化、自动化、不落地处理，提升结算效率、加速资金流转、提升整体效益，通过加强内部资金统一调配，加速内部资金周转、降低资金沉淀量、提高整体资金使用效益。通过银企直联、RPA网银机器人完成资金的统一支付，并通过头寸管理结合资金计划严控资金头寸，保障资金安全。
                </p>
                <p>同时实现资金的逆向流程线上管理，实现对于错付退回、银行账户有误逆向流程的线上审批，避免出现重付、多付、账务核算错误、账户错误无人监控的情况。</p>
                <img class="imgmian2 mrgintop0 mt3" src="@/assets/images/portfolio/dialog/eec/资金结算.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '6'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">移动应用</div>
              <div class="bar"></div>
              <div class="conts mt3">
                <div class="contentBox width55">
                  <div>移动报销：将费用报销与费用申请、事务申请、金额管控、发票管控等集成，并结合预算管控、成本中心管控要求，实现费用归集，并通过报表展示费用的发生情况。</div>
                  <div class="mgtop10">移动审批：用户随时随地通过APP、钉钉、企业微信、飞书、企业OA等多种社交软件使用审批功能，对要素事项进行提醒，感受审批便捷。
                  </div>
                </div>
                <img class='imgeec1-3' src="@/assets/images/portfolio/dialog/eec/移动应用.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '7'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">连接器</div>
              <div class="bar"></div>
              <div class="conts mt3">
                <p class="width55">EECloud的Business
                  Connector（连接器模块），通过连接器将其他业务系统等无缝与EECloud整合。通过统一数据连接器充分结合，让连接+报账实现业财的全面融合。</p>
                <img class='imgeec1-3' src="@/assets/images/portfolio/dialog/eec/连接器.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '8'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <h3 class="fs-2 w-700 lyd-title-colo1">会计引擎</h3>
              <div class="bar"></div>
              <div class="cont">
                <div class="contentBox">
                  <p>当企业已经有核算系统时，通过EECloud会计引擎，智能化、自动化生成财务核算系统凭证，实现智能记账。</p>
                  <p>
                    EECloud会计引擎可定义、可配置不同行业和企业性质的凭证生成模板，只需会计知识即可。具有与用友、金蝶、浪潮、SAP、ORACLE等不同的产品系列集成实践经验，EECloud通过会计引擎都能迅速地、自动化生成会计凭证。
                  </p>
                </div>
                <img class="imgmian2 mrgintop0 mt3" src="@/assets/images/portfolio/dialog/eec/会计引擎.png" alt="" />
              </div>
            </div>
            <div class="two" style="margin-top: 90px;">
              <div class="fs-2 w-700 lyd-title-colo1">整体价值</div>
              <div class="bar"></div>
              <div class="cont2">
                <ul class="padHeight">
                  <li>多元化、多层级，因地制宜推行业财融合。</li>
                  <li>破壁垒、通数据，解除业务发展困局。</li>
                  <li>控风险、创价值，业财融合助力企业经营。</li>
                </ul>
              </div>
            </div>
            <div class="two" style="margin-top: 90px;">
              <div class="fs-2 w-700 lyd-title-colo1">产品优势</div>
              <div class="bar"></div>
              <div class="cont2">
                <ul class="padHeight">
                  <li>提高灵活：增强企业规模扩大的潜力。</li>
                  <li>业财深度融合：财务人员更加深入地参与到业务活动当中，更好为业务提供服务，将财务组织打造成“企业业务伙伴”。</li>
                  <li>强化数据应用：对财务信息统一治理，避免信息孤岛，加强企业财务数据的分析洞察。</li>
                  <li>实现降本增效：能力复用，避免资源浪费，降低经营成本，提高综合运营效率。</li>
                  <li>助力转型升级：将财务人员从传统事务性工作中释放出来，转向从事企业决策辅助等高价值工作。</li>
                  <li>提升智能化程度：借助业务和数据的融合，充分考虑人工智能、高级分析等新兴技术的应用，打造“智慧”财务，将财务管理工作推入“AI”赛道。</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '9'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">共享运营平台</div>
              <div class="bar"></div>
              <div class="cont">
                <div class="contentBox">
                  <p>
                    任务提取规则、任务派单规则、单据模板设置、共享服务中心任务处理、作业任务管理、任务查询、绩效考评等模块。
                  </p>
                  <ul class="padHeight">
                    <li>
                      委托组织：灵活定义业务组织提交业务（费用管理、应收管理、应付管理、资金管
                      理、自有表单模块业务）单据后，可以委托哪个共享服务中心处理-补图；
                    </li>
                    <li>任务量设定：可按需设置限制作业人员的在手待处理任务量，提升共享作业效率；</li>
                    <li>派单规则：可以科学按业务组织、单据类型、交易类型、高级条件等不同维度设置派单规则；</li>
                    <li>
                      共享任务作业平台：基于角色的门户应用提供一站式工作起点、提供专事专岗统一界面进行集中作业审核处理，提供双屏审单、自动制证提高工作效率，通过对工作量的计量、量比实现规范运营和质量管控。
                    </li>
                  </ul>
                </div>
                <div class="contentImg mgbot15">
                  <div class="tit">
                    <div class="fs-3 w-700 lyd-title-colo1">产品架构</div>
                    <div class="bar"></div>
                  </div>
                  <img class="jiagou1 mrgintop0" src="../assets/images/portfolio/dialog/eec/共享运营平台1.png" alt="" />
                </div>
              </div>
            </div>
            <div class="two">
              <div class="fs-2 w-700 lyd-title-colo1">产品模块</div>
              <div class="bar"></div>
              <div class="cont2 mt3">
                <p>
                  共享运营平台作为共享服务中心人员日常工作、管理的主要平台，包括：共享组织架构、任务提取规则、任务派单规则、共享服务中心任务处理、作业任务管理、任务查询、绩效管理等模块。
                </p>

                <ul class="padHeight">
                  <li>
                    <div>共享组织架构</div>
                    <div class="padHeight-item">
                      <p>
                        实现共享服务委托关系以及共享中心岗位设置，支持一个企业按照板块、区域业务模式差异划分多个共享中心，共享中心下设作业处理小组及业务岗位，系统支持分级设置岗位且可针对不能级次的岗位实现权限划分。
                      </p>
                      <img src="../assets/images/portfolio/dialog/eec/共享运营平台2.png" alt="" />
                    </div>
                  </li>
                  <li>
                    <div>任务提取规则</div>
                    <div class="padHeight-item">
                      <p>
                        任务提取规则是财务共享服务中心的基础设置，用于定义每次提取任务量，设置是否要限制作业人员的在手待处理任务量。用于避免业务人员一次提取过多的任务，导致任务压单，影响业务的处理效率和客户满意度。
                      </p>
                      <img src="../assets/images/portfolio/dialog/eec/共享运营平台3.png" alt="" />

                    </div>
                  </li>
                  <li>
                    <div>任务派单规则</div>
                    <p class="mt3">
                      任务派单规则是共享服务中心的管理员可以使用此功能将任务分配给具体岗位，派单规则是系统对任务池派工时的分组派送的依据，规则的设置直接影响后续任务处理时的任务提取和任务分配与调整的可操作任务范围。对于一些难度比较大的作业，可以通过任务派单规则指派给比较有经验的人员来进行处理，确保业务处理的效率和质量。
                    </p>
                  </li>
                  <li>
                    <div>作业任务处理</div>
                    <div class="padHeight-item">
                      <p>
                        共享服务中心的业务人员可以通过此节点提取并处理任务，处理自的日常业务。共享作业人员可对单据进行审批通过或者驳回操作，支持将单据驳回影像岗位进行影像调整，支持将提取到单据申请调整至其他作业人员审批。
                      </p>
                      <img src="../assets/images/portfolio/dialog/eec/共享运营平台4.png" alt="" />
                    </div>
                  </li>
                  <li>
                    <div>作业任务管理</div>

                    <div class="padHeight-item">
                      <p>
                        任务管理主要是针对业务组长的，业务组长可以通过调整任务优先级等方式，将任务池中的未分配的任务指派给本组组员、将已分配未处理的任务取回到任务池。
                      </p>
                      <img src="../assets/images/portfolio/dialog/eec/共享运营平台5.png" alt="" />
                    </div>
                  </li>
                  <li>
                    <div>任务查询</div>
                    <p class="mt3">
                      共享服务中心的负责人可以通过任务查询，对任务池进行查询统计，查看任务池中不同状态的任务量，任务详细信息，任务处理时效等信息。
                    </p>
                  </li>
                  <li>
                    <div>绩效管理</div>
                    <div class="padHeight-item">
                      <p>共享绩效数字厅反映共享服务中心的单据处理量、单据处理效率、单据报账周期、退单率等信息。</p>
                      <img src="../assets/images/portfolio/dialog/eec/共享运营平台6.png" alt="" />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="two">
              <div class="fs-2 w-700">整体价值</div>
              <div class="bar"></div>
              <div class="cont2">
                <ul class="padHeight">
                  <li>
                    <div>系统稳定:</div>
                    <p>
                      建立多重预防性维护（如高质可用架构、系统效率监控、周期性性能检查等），提前识别操作风险，并进行及时处理
                    </p>
                  </li>
                  <li>
                    <div>降低成本：</div>
                    <p>通过共享模式的管理可以有效的降低总体成本（包括硬件投入成本、软件成本、人工成本等）</p>
                  </li>
                  <li>
                    <div>降低负担：</div>
                    <p>通过自动化，将低附加值的工作外包来替代运营人员的工作，让运营人员聚焦到更有价值的事务上；</p>
                  </li>
                  <li>
                    <div>价值提升：</div>
                    <p>通过财务共享运营实现业务转型创新，从运营层面报账财务共享中心工作预期目标得以实现。</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right" v-if="val == 3">
        <div v-if="leftInd == '0'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">进项管理</div>
              <div class="bar"></div>
              <div class="conts mt3">
                <div class="contentBox width55">
                  <p>进项管理实现发票采集、价税分离、报账、专票抵扣勾选、统计签名、进项转出等税务业务处理，系统出具抵扣明细及汇总表。</p>
                  <p>票小记发票夹提供APP和微信小程序两种使用途径。</p>
                </div>
                <img class='imgeec1-3' src="../assets/images/portfolio/dialog/eec/增值税管理云2.png" alt="" />
              </div>
              <div class="conts mt3">
                <dic class="contentBox width55">
                  <p>单据关联发票进行报账，实现发票与单据以及影像一体化，依据税法规定自动进行价税分离，降低了税务风险，提高了报账效率。</p>
                  <p>与核算系统集成，实现发票与凭证信息关联，系统自动识别专票等可抵扣发票生成待认证清单，与税局打通可按入账月份完成一键认证；</p>
                </dic>
                <img class='imgeec1-3' src="../assets/images/portfolio/dialog/eec/增值税管理云3.png" alt="" />
              </div>
              <div class="conts mt3">
                <div class="contentBox width55">
                  <p>增值税系统按照预设的规则将福利费发票、用于简易计税项目的发票，被红冲的发票等生成待转出清单，可批量进行转出生成单据、附件以及会计凭证。</p>
                </div>
                <img class='imgeec1-3' src="../assets/images/portfolio/dialog/eec/增值税管理云4.png" alt="" />
              </div>
              <div class="conts mt3">
                <div class="contentBox width55">
                  <p>增值税系统出具进项发票台账、抵扣统计表以及其他扣税明细表等统计报表且关联单据以及财务入账凭证，便于税务人员进行查询统计。</p>
                </div>
                <img class='imgeec1-3' src="../assets/images/portfolio/dialog/eec/增值税管理云5.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '1'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">销项管理</div>
              <div class="bar"></div>
              <div class="conts mt3">
                <div class="contentBox width55">
                  <p>
                    销项管理实现开票申请，开票流程管理、开票限额拆分、余票管理，单张及批量开票、发票作废、发票冲红、发票打印等销项开票业务处理，系统出具销项明细及汇总表。
                  </p>
                  <p>与业务系统打通，实现开票申请从业务到财务一体化关联，与税局打通，实现批量开票，解放了开票人员的繁重的工作，规范了开票流程，降低了开票的出错率。</p>
                  <p>支持发票作废，红冲等开票业务，全面覆盖了所有销项开票业务，且发票作废后支持多种方式发起重开；</p>
                </div>
                <img class='imgeec1-3' src="../assets/images/portfolio/dialog/eec/增值税管理云6.png" alt="" />
              </div>
              <dic class="conts mt3">
                <div class="contentBox width55">
                  <p>与业务系统打通，在增值税系统完成开票后，将开票结果回传业务系统，以便于业务人员实时查看，节省了业务与财务的沟通成本。</p>
                  <p>增值税系统出具销项发票台账以及销项发票汇总表，便于开票人员查看和统计，为后续税务业务处理提供了数据支撑。</p>
                </div>
                <img class="imgeec1-3" src="../assets/images/portfolio/dialog/eec/增值税管理云7.png" alt="" />
              </dic>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '2'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">申报管理</div>
              <div class="bar"></div>
              <div class="cont">
                <div class="contentBox">
                  <p>支持全税种申报，可以依据企业性质选择报表。系统分为纳税申报、涉税查询、申报作废三大模块。</p>
                  <p>纳税申报，包括处理综合申报、个税申报数据上传、财务数据填报等业务。</p>
                  <p>涉税查询为企业提供月度申报情况查询，可进行汇总、分析、打印等，便于企业与税局机关核对，企业可直接在网上实现缴税，具体功能实现了数智化。</p>
                  <p>申报作废主要对于当期已申报发现错误的数据进行作废，可重新调整申报数据。</p>
                </div>
                <img class="imgmian2 mrgintop0 mt3" src="@/assets/images/portfolio/dialog/eec/纳税申报配图.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right" v-if="val == 4">
        <div v-if="leftInd == '0'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">账户管理</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>将企业的银行账户的开立、变更、冻结、注销纳入管理，实时呈现账户数、账户金额。</p>
                </div>
                <img class="imgmian2 mrgintop0 mt3" src="../assets/images/portfolio/dialog/eec/全球司库管理云2.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '1'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">资金结算</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>资金结算管理包括收付款、内部结算、资金的归集和划拨等功能，并提供大量的资金分析报表和系统业务预警报表，帮助企业集团管理者及时了解资金情况、账户余额、存款到期等资金数据。
                  </p>
                </div>
                <img class="imgmian2 mrgintop0 mt3" src="../assets/images/portfolio/dialog/eec/全球司库管理云3.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '2'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">融资管理</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>
                    融资管理提供集团和成员企业信贷业务全过程管理，实现集团信贷业务的流程化、规范化。通过系统可实时掌握银行授信额度的整体情况，依据成员企业运营情况在集团内进行有效调配。可对集团内外融资业务进行全面监控与跟踪，防范企业信贷风险，提高信贷资金的使用效益。
                  </p>
                </div>
                <img class="imgmian2  mrgintop0 mt3" src="../assets/images/portfolio/dialog/eec/全球司库管理云4.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '3'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">资金集中管理</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>
                    帮助企业建立资金集中管理和资金集中监控的平台，实现账户集中管控和实时监控，并实现收支两条线的资金管理模式。通过资金收支两条线管理，加强对下属公司资金的监控，盘活企业存量资金，提高资金使用效率和使用效果，并降低资金运作成本和风险，保证资金安全。实现与资金结算、资金计划、融资管理、账户管理、票证管理等子系统无缝衔接，对于收支情况进行统筹管理，实时分析。
                  </p>
                </div>
                <img class="imgmian2  mrgintop0 mt3" src="../assets/images/portfolio/dialog/eec/全球司库管理云6.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '4'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">票据管理</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>票据管理是为企业提供票据的收发、背书、贴现、到期收付、质押、托管等业务的集中处理平台，帮助企业实现票据的全生命周期管理。其功能主要涵盖票据管理平台、票据池管理、对接资金管理系统等模块。
                  </p>
                </div>
                <img class="imgmian2  mrgintop0 mt3" src="../assets/images/portfolio/dialog/eec/全球司库管理云5.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '5'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">供应链金融</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>
                    供应链金融应用于供应链融资流程、风控管理、授信评分、贷后监控等方面从而实现融资申请、贷前调查、贷款审核、合同签订、贷后跟踪、催收管理流程化，规范供应链发展。搭建线上线下风控模块，从融资资格、融资额度、材料审核、项目审批等多个环节进行科学管理；对供应商、经销商等角色进行授信审核，自定义评分卡模块，生成对应的授信额度与建议年化折价率。实时更新欺诈信息库，定期对存量用户检测，及时发现跨平台逾期、多头借贷、用户异动等风险。
                  </p>
                </div>
                <img class="imgmian2  mrgintop0 mt3" src="../assets/images/portfolio/dialog/eec/全球司库管理云7.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right" v-if="val == 5">
        <div v-if="leftInd == '0'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700">收款认领</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>
                    通过RPA技术将所有收款信息形成结构化数据导入收款认领模块，形成收款单据。同时下载对应收款回单附件信息，将回单信息同步，自动关联收款单据，收款单生效后可以直接通过单据联查回单，联查凭证，以及通过凭证联查回单等，实现三单穿透联查。
                  </p>
                </div>
                <img class="imgmian2  mrgintop0 mt3" src="../assets/images/portfolio/dialog/eec/智慧网银云2.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '1'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700">资金监控</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>对企业资金流入流出情况、实时余额、当月总流入、当月总流出等参数进行实时监控查看。同时涵盖资金付款预测、资金头寸预测、监控账户、资金地图、支付方式对比、付款排名、支付方式占比、资金监控报告等功能。
                  </p>
                </div>
                <img class="imgmian2  mrgintop0 mt3" src="../assets/images/portfolio/dialog/eec/智慧网银云3.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '2'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700">银行对账</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>自动将银行流水（收/付）与资金结算模块数据进行核对，将每一笔流水明细与每一笔结算单据进行关联核对，最终形成比对差异，自动形成余额调节表。</p>
                </div>
                <img class="imgmian2  mrgintop0 mt3" src="@/assets/images/portfolio/dialog/eec/智慧网银云4.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '3'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700">票据管理</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>
                    票据管理和收款认领为企业两大主要资金流入来源，票据签收具有数据下载勾选认领模式，在票据勾选签收后RPA自动登录网银系统完成票据签收，签收完成后自动登录票据系统完成收票登记、生成收款单、自动完成内部托管等，整个票据流程中可完全脱离手工操作。
                  </p>
                </div>
                <img class="imgmian2  mrgintop0 mt3" src="@/assets/images/portfolio/dialog/eec/智慧网银云5.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right" v-if="val == 7">
        <div v-if="leftInd == '0'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700">智能报表</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>智能报表支持在多会计准则、多币种、法定及管理多组织架构等各种复杂环境下，准确、自动生成报表。</p>
                  <img class="imgmian2 mrgintop0 mt3" src="@/assets/images/portfolio/dialog/esc/reportForm.jpeg"
                    alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="leftInd == '1'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700">智能分析管理</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>智能分析通过业财数据中台，对企业过去、评价企业现状、预测企业未来做出正确决策提供准确的信息和依据。</p>
                  <p>智能分析包括盈利能力分析、偿债能力分析、资产运营能力分析、发展能力分析等。</p>
                </div>
                <img class="imgmian2  mrgintop0 mt3" src="../assets/images/portfolio/dialog/eec/智能分析云1.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="closes" @click="close">
        <!-- <i class="bi bi-arrow-return-left"></i> -->
        <!-- <i class="bi bi-arrow-right-square-fill"></i> -->
        <div class="clo-btn">返回<i class="bi bi-chevron-right"></i></div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.Dialog {
  h5 {
    font-size: 16px !important;
  }

  li {
    font-size: 16px !important;
  }

  img {
    text-align: center;
    height: auto
  }

  .padHeight {
    margin: 3rem 0;
  }

  .flex-one {
    display: flex;
    align-items: center;
    justify-content: space-between;

    // width: 90%;
    p {
      width: 55%;
      flex-shrink: 0;
      font-size: 1.6rem !important
    }

    .flex-one-img1 {
      width: 50rem !important
    }

    .flex-one-img2 {
      width: 70rem !important
    }
  }

  .right-top {
    .one {
      .cont {
        margin: 3rem 0;
        // height: calc(100vh - 220px);
        display: block !important;

        .contentBox {
          //   width: 80rem;
          margin-right: 5rem;
        }

        img {
          // width: 22rem;
          // height: 11rem;
        }
      }
    }

    .two {
      .cont2 {
        .tags {
          display: flex;

          .tag {
            opacity: 0.988;
            //width: 130px;
            padding: 10px 20px;
            margin: 0 5px;
            height: 45px;
            border: 1px solid #99a5bb;
            border-radius: 20px;
            cursor: pointer;
          }
        }

        .industry {
          display: flex;
          justify-content: space-around;

          li {
            list-style: none;

            .padHeight-item {
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
            }
          }
        }
      }
    }
  }

  .padHeight {
    margin: 3rem 0;

    .padHeight-item {
      display: flex;
      margin-top: 3rem;
      // align-items: center;
      justify-content: space-between;

      p {
        width: 55%;
      }

    }
  }

  // p {
  // 	margin: 2rem 0;
  // }

  .active {
    background: url("../assets/images/portfolio/dialog/click-bg.png");
    color: #333 !important;
  }

  .active2 {
    background: #005bab;
    color: white;
  }

  .bar {
    height: 3px;
    width: 25px;
    background: #005bab;
  }

  .bar-center {
    margin: 0 auto;
  }

  .mt3 {
    margin-top: 3rem;
  }

  .mb10 {
    margin-bottom: 10rem !important;
  }

  .imgmian2 {
    width: 80rem !important;
  }

  .padHeight_imgmian2 {
    width: 70rem !important;
    height: 35rem !important;
  }

  .imgmian1 {
    width: 80rem !important;
    margin-top: 7rem !important;
    margin-bottom: 10rem !important;
  }

  .margin0auto {
    margin: 0 auto;
    display: block;
  }

  .imgeec1-1 {
    width: 50rem !important;
  }

  .imgeec1-2 {
    height: 18.5rem !important;
  }

  .imgeec1-3 {
    width: 500px
  }

  .imgeec1-4 {
    width: 800px
  }

  .imgeec1-100 {
    width: 100%
  }

  .conts-alinetimecenter {
    align-items: center;
  }

  .width55 {
    width: 55% !important
  }

  .width80 {
    width: 80% !important
  }

  .width100 {
    width: 100% !important
  }
}
</style>
<style lang="scss">
.Dialog {
  display: block;

  .mrgintop0 {
    display: block;
    margin: 0 auto;
  }

  .tit {
    margin-top: 10rem;
    margin-bottom: 5rem;
  }

  .mgtop10 {
    margin-top: 10rem;
  }

  .mgbot10 {
    margin-bottom: 5rem;
  }

  .mgbot15 {
    margin-bottom: 10rem;
  }

  .jiagou1 {
    height: 40rem !important;
  }

  .main {
    position: fixed;
    top: 80px;
    display: flex;
    justify-content: center;
    width: 100vw;
    max-width: 1920px;

    .left {
      background: url("../assets/images/portfolio/dialog/dialog-left.png");
      width: 380px;
      height: calc(100vh - 80px);
      padding-top: 10vh;
      overflow: auto;

      .left-tab {
        width: 380px;
        height: 120px;
        color: #fff;
        text-align: center;
        line-height: 120px;
        cursor: pointer;
      }
    }

    .right {
      // max-width: 1200px;
      flex: 1;
      height: 100%;
      background: #fff;
      padding: 2rem 5rem;
      overflow: auto;
      height: calc(100vh - 80px);

      .right-top {
        .one {
          .cont {
            margin: 3rem 0;

            .contentBox {
              margin-right: 5rem;

              p {
                font-size: 1.6rem !important
              }

              .contentBoxContent {
                display: flex;

                .ContentBoxs {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-around;
                  flex: 1;
                }

                img {
                  flex: 1;
                }
              }
            }

            .contentImg {
              img {
                // width: 22rem;
                // height: 11rem;
              }
            }

            img {
              // width: 70rem;
              // height: 40rem;
            }

            .reimbursement1 {
              width: 100%;
            }

            .reimbursement2 {
              width: 80%;
            }

            .reimbursementImg1 {
              width: 90rem;
            }
          }

          .conts {
            display: flex;
            height: 30rem;
            align-items: center;
            justify-content: space-between;

            .contentBox {
              // flex: 1;
            }

            img {
              // flex: 1;
            }
          }
        }

        .two {
          .cont2 {
            .tags {
              display: flex;
              margin-top: 6rem;
              flex-wrap: wrap;

              .tag {
                opacity: 0.988;
                //width: 130px;
                padding: 10px 20px;
                margin: 0 5px;
                height: 45px;
                border: 1px solid #99a5bb;
                border-radius: 20px;
                cursor: pointer;
              }
            }
          }

          .cont3 {
            display: flex;

            .cont3_box {
              display: flex;
              align-items: center;
              flex: 1;
              justify-content: space-around;

              img {
                width: 10rem;
                height: 10rem;
              }

              .cont3_box_test {
                width: 40rem;
              }
            }
          }
        }
      }

      .bottom {
        margin-top: 3rem;
      }
    }
  }

  .closes {
    //transform: scale(1.8);
    top: 2rem;
    right: 2rem;
    position: absolute;
    cursor: pointer;

    .clo-btn {
      font-size: 10px;
      width: 60px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border: 1px solid #676767;
      border-radius: 5px;
      background: #f9f9f9;
    }
  }
}

.padHeight {
  margin: 3rem 0;
}

.padHeights {
  li {
    display: flex;

    .padHeights_test {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      flex: 1;
    }

    .fill {
      width: 112rem;
      height: 25.5rem;
    }
  }

  .padHeights_li {
    display: flex;

    .padHeights_tests {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }

    .fill {
      width: 42rem;
      height: 25.5rem;
    }
  }

  .padHeights_lis {
    display: flex;
    align-items: center;

    .padHeights_img {
      width: 10rem !important;
      height: 10rem !important;
      border-radius: 50%;
    }
  }
}
</style>
<script>
import tags from "@/components/common/dialog/tags.vue"
export default {
  name: "Dialog",
  components: { tags },
  props: {
    leftInd: '',
    leftCur: '',
    val: '',
  },
  data() {
    return {
      leftTabs: [
        [{ tab: "智能合同管理平台" }, { tab: "智慧业财管理平台" }, { tab: "共享运营平台" }, { tab: "行业特性" }],
        [{ tab: "智能合同管理" }, { tab: "智能报账" }, { tab: "发票管理" }, { tab: "电子影像与电子档案管理" }, { tab: "一键报税" },
        { tab: "资金结算" }, { tab: "移动应用" }, { tab: "连接器" }, { tab: "会计引擎" }, { tab: "共享运营平台" }],
        [{ tab: "进项管理" }, { tab: "销项管理" }, { tab: "申报管理" }],
        [{ tab: "账户管理" }, { tab: "资金结算" }, { tab: "融资管理" }, { tab: "资金集中管理" }, { tab: "票据管理" },
        { tab: "供应链金融" }],
        [{ tab: "收款认领" }, { tab: "资金监控" }, { tab: "银行对账" }, { tab: "票据管理" }],
        [],
        [{ tab: "智能报表" }, { tab: "智能分析管理" }],
      ],
      rightCur: "",
      rightTabs: [
        { tag: "智能报账" },
        { tag: "发票管理" },
        { tag: "电子影像与电子档案管理" },
        { tag: "一键报税" },
        { tag: "资金结算" },
        { tag: "连接器" },
        { tag: "会计引擎" },
        { tag: "移动应用" },
      ],
      ind: "1",
    }
  },
  methods: {
    bg(index) {
      this.$emit('tochange', index)
    },
    tag(index) {
      this.rightCur = index
      this.ind = index + 1
    },
    close() {
      this.$emit('toclose', '')
    },
  },
}
</script>
